export const TRANSPORT_FAQS = [
  {
    question: "How much does auto transport cost?",
    answer: "One-way transport between Lakewood, NJ and Orlando, FL is $1,500. Round trip (to Orlando before Pesach and back after) is $2,800. You can save $35 on one-way or $70 on round trip by paying with Zelle instead of credit card."
  },
  {
    question: "Is my vehicle insured during transport?",
    answer: "Yes. Your vehicle is covered by our $250,000 Motor Truck Cargo Insurance while it is physically secured on our trailer.\n\nDuring Transit: Full coverage under our primary cargo policy.\n\nShuttle Driving: Your personal auto insurance remains the primary coverage while the vehicle is being driven to or from the trailer as per our service agreement.\n\nVerification: A Certificate of Insurance (COI) is available upon request."
  },
  {
    question: "How long does the transport take?",
    answer: "Transport between Lakewood, NJ and Orlando, FL typically takes 2-3 business days depending on weather and road conditions. We coordinate pickup and delivery times to fit your schedule."
  },
  {
    question: "When should I book for Pesach 2026?",
    answer: "We recommend booking as early as possible. Spaces fill up quickly as Pesach approaches. Early booking guarantees your preferred pickup and delivery dates."
  },
  {
    question: "What payment methods do you accept?",
    answer: "We accept all major credit and debit cards through Stripe, as well as Zelle payments. Paying with Zelle saves you $35 on one-way trips or $70 on round trips."
  },
  {
    question: "Is the service door-to-door?",
    answer: "Yes, we provide convenient door-to-door service. We pick up your vehicle at your specified address in Lakewood, NJ (or Orlando, FL) and deliver it directly to your destination address."
  },
  {
    question: "What types of vehicles do you transport?",
    answer: "We transport all standard passenger vehicles including sedans, SUVs, minivans, and full-size vehicles. If you have a special vehicle, contact us and we'll be happy to accommodate."
  },
  {
    question: "Can I transport personal items with my vehicle?",
    answer: "Yes. We provide a dedicated truck for luggage at no additional cost. While DOT regulations prohibit personal items inside the vehicle during transit, our dual-transport system ensures your belongings move with your car in a fully compliant, secure environment."
  }
];

export const CLEANING_FAQS = [
  {
    question: "What cleaning services do you offer?",
    answer: "We offer two packages: the Platinum Package (Pesach cleaning with Chametz-free guarantee, interior only) and Full Detailing (complete interior and exterior detail with waxing, leather conditioning, and more)."
  },
  {
    question: "Is the Pesach cleaning guaranteed Chametz-free?",
    answer: "Yes, our Platinum Package is specifically designed for Pesach preparation. We guarantee thorough Chametz-free cleaning of your vehicle's entire interior, including hard-to-reach areas, crevices, and under seats."
  },
  {
    question: "How long does the cleaning take?",
    answer: "Cleaning times vary by vehicle size. For the Platinum Package: Sedan 45-60 minutes, 2 Row SUV 60-75 minutes, 3 Row SUV 75-90 minutes, and Minivan 90-120 minutes. Full Detailing takes approximately twice as long."
  },
  {
    question: "Do you come to my location?",
    answer: "Yes! We are a fully mobile service. We bring all professional equipment and products directly to your driveway or parking spot. No need to drop off your vehicle anywhere."
  },
  {
    question: "Can I book multiple vehicles at once?",
    answer: "Absolutely! Our booking system supports multi-vehicle bookings. You can add multiple vehicles to a single appointment, and the total price is calculated automatically for each vehicle."
  },
  {
    question: "What's included in the Platinum Package?",
    answer: "The Platinum Package includes thorough interior cleaning: deep vacuuming of seats, carpets, and mats, dashboard and console wipe down, cup holder cleaning, door panel cleaning, interior window cleaning, and air freshener application."
  },
  {
    question: "What's included in Full Detailing?",
    answer: "Full Detailing covers both exterior (hand washing, clay bar treatment, waxing/sealing, trim restoration, window cleaning) and interior (deep vacuuming, carpet and upholstery cleaning, leather conditioning, dashboard detailing, vent and crevice cleaning)."
  },
  {
    question: "How much does car cleaning cost?",
    answer: "Platinum Package starts at $85 for sedans, $105 for 2 Row SUVs, $115 for 3 Row SUVs, and $125 for minivans. Full Detailing starts at $200 for sedans, $260 for 2 Row SUVs, $300 for 3 Row SUVs, and $350 for minivans."
  },
  {
    question: "Should I remove car seats before the cleaning?",
    answer: "We recommend removing car seats before your appointment for the most thorough cleaning, especially for Pesach preparation. This allows us to clean all areas underneath and around the car seat mounts."
  },
  {
    question: "How do I schedule an appointment?",
    answer: "Simply click 'Book Now' on our website, select your service type and vehicle size, enter your vehicle and contact details, choose your preferred date and time, and complete payment. You'll receive a confirmation email with all the details."
  }
];
